
// @ts-nocheck


export const localeCodes =  [
  "at",
  "be",
  "fr-be",
  "ch",
  "fr-ch",
  "de",
  "fr",
  "nl",
  "uk"
]

export const localeLoaders = {
  at: [
    {
      key: "locale_de_45AT_46json_bd555b9b",
      load: () => import("#nuxt-i18n/bd555b9b" /* webpackChunkName: "locale_de_45AT_46json_bd555b9b" */),
      cache: true
    }
  ],
  be: [
    {
      key: "locale_nl_45BE_46json_4cc2660e",
      load: () => import("#nuxt-i18n/4cc2660e" /* webpackChunkName: "locale_nl_45BE_46json_4cc2660e" */),
      cache: true
    }
  ],
  "fr-be": [
    {
      key: "locale_fr_45BE_46json_ec5e3528",
      load: () => import("#nuxt-i18n/ec5e3528" /* webpackChunkName: "locale_fr_45BE_46json_ec5e3528" */),
      cache: true
    }
  ],
  ch: [
    {
      key: "locale_de_45CH_46json_501913d1",
      load: () => import("#nuxt-i18n/501913d1" /* webpackChunkName: "locale_de_45CH_46json_501913d1" */),
      cache: true
    }
  ],
  "fr-ch": [
    {
      key: "locale_fr_45CH_46json_acf151ad",
      load: () => import("#nuxt-i18n/acf151ad" /* webpackChunkName: "locale_fr_45CH_46json_acf151ad" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_45DE_46json_04f9d18b",
      load: () => import("#nuxt-i18n/04f9d18b" /* webpackChunkName: "locale_de_45DE_46json_04f9d18b" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_45FR_46json_626f0d66",
      load: () => import("#nuxt-i18n/626f0d66" /* webpackChunkName: "locale_fr_45FR_46json_626f0d66" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_45NL_46json_67393596",
      load: () => import("#nuxt-i18n/67393596" /* webpackChunkName: "locale_nl_45NL_46json_67393596" */),
      cache: true
    }
  ],
  uk: [
    {
      key: "locale_en_45GB_46json_793b8b37",
      load: () => import("#nuxt-i18n/793b8b37" /* webpackChunkName: "locale_en_45GB_46json_793b8b37" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "at",
      iso: "de-AT",
      domain: "",
      files: [
        {
          path: "/app/apps/mad/i18n/langs/de-AT.json",
          cache: undefined
        }
      ]
    },
    {
      code: "be",
      iso: "nl-BE",
      domain: "",
      files: [
        {
          path: "/app/apps/mad/i18n/langs/nl-BE.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr-be",
      iso: "fr-BE",
      domain: "",
      files: [
        {
          path: "/app/apps/mad/i18n/langs/fr-BE.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ch",
      iso: "de-CH",
      domain: "",
      files: [
        {
          path: "/app/apps/mad/i18n/langs/de-CH.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr-ch",
      iso: "fr-CH",
      domain: "",
      files: [
        {
          path: "/app/apps/mad/i18n/langs/fr-CH.json",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      iso: "de-DE",
      domain: "",
      files: [
        {
          path: "/app/apps/mad/i18n/langs/de-DE.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      iso: "fr-FR",
      domain: "",
      files: [
        {
          path: "/app/apps/mad/i18n/langs/fr-FR.json",
          cache: undefined
        }
      ]
    },
    {
      code: "nl",
      iso: "nl-NL",
      domain: "",
      files: [
        {
          path: "/app/apps/mad/i18n/langs/nl-NL.json",
          cache: undefined
        }
      ]
    },
    {
      code: "uk",
      iso: "en-GB",
      domain: "",
      files: [
        {
          path: "/app/apps/mad/i18n/langs/en-GB.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "de",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix",
  lazy: true,
  langDir: "langs/",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "at",
    iso: "de-AT",
    domain: "",
    files: [
      {
        path: "/app/apps/mad/i18n/langs/de-AT.json",
        cache: undefined
      }
    ]
  },
  {
    code: "be",
    iso: "nl-BE",
    domain: "",
    files: [
      {
        path: "/app/apps/mad/i18n/langs/nl-BE.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr-be",
    iso: "fr-BE",
    domain: "",
    files: [
      {
        path: "/app/apps/mad/i18n/langs/fr-BE.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ch",
    iso: "de-CH",
    domain: "",
    files: [
      {
        path: "/app/apps/mad/i18n/langs/de-CH.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr-ch",
    iso: "fr-CH",
    domain: "",
    files: [
      {
        path: "/app/apps/mad/i18n/langs/fr-CH.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    iso: "de-DE",
    domain: "",
    files: [
      {
        path: "/app/apps/mad/i18n/langs/de-DE.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    iso: "fr-FR",
    domain: "",
    files: [
      {
        path: "/app/apps/mad/i18n/langs/fr-FR.json",
        cache: undefined
      }
    ]
  },
  {
    code: "nl",
    iso: "nl-NL",
    domain: "",
    files: [
      {
        path: "/app/apps/mad/i18n/langs/nl-NL.json",
        cache: undefined
      }
    ]
  },
  {
    code: "uk",
    iso: "en-GB",
    domain: "",
    files: [
      {
        path: "/app/apps/mad/i18n/langs/en-GB.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/